export default [
  {
    // =============================================================================
    // PROJECT LAYOUT ROUTES
    // =============================================================================
    path: '/m/project/:proj_id',
    component: () => import('@/layouts/m/project/Index.vue'),
    meta:{
      authRequired: true
    },
    redirect: '/m/project/:proj_id/home',
    children: [
      // 대시보드
      {
        path: 'home',
        name: 'm-project-home',
        component: () => import('@/views/m/project/Index.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: 'breadcrumb.home.dashboard'},
            {
              title: '프로젝트',
              active: true
            }
          ],
          pageTitle: 'breadcrumb.home.dashboard'
        }
      },
      {
        path: 'alert',
        name: 'm-project-alert',
        component: () => import('@/views/m/project/Alert.vue')
      },
      {
        path: 'input-check',
        name: 'm-project-input-check',
        component: () => import('@/views/m/project/InputCheck.vue')
      },
      {
        path: 'input-check-log',
        name: 'm-project-input-check-log',
        component: () => import('@/views/m/project/InputCheckLog.vue')
      },
      {
        path: 'photo-album',
        name: 'm-project-photo-album',
        component: () => import('@/views/m/project/PhotoAlbum.vue')
      },

      // 안전실적
      {
        path: 'safety/regular-assessment',
        name: 'm-project-safety-reqular-assessment',
        component: () => import('@/views/m/project/safety/MobileSafetyRegularAssessment.vue'),
        meta: {
        }
      },
      {
        path: 'safety/regular-assessment-create',
        name: 'm-project-safety-reqular-assessment-create',
        component: () => import('@/views/m/project/safety/MobileSafetyRegularAssessmentCreate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/regular-assessment-update',
        name: 'm-project-safety-reqular-assessment-update',
        component: () => import('@/views/m/project/safety/MobileSafetyRegularAssessmentUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/regular-assessment-always',
        name: 'm-project-safety-reqular-assessment-always',
        component: () => import('@/views/m/project/safety/MobileSafetyRegularAssessmentAlways.vue'),
        meta: {
        }
      },
      {
        path: 'safety/regular-assessment-always-create',
        name: 'm-project-safety-reqular-assessment-always-create',
        component: () => import('@/views/m/project/safety/MobileSafetyRegularAssessmentAlwaysCreate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/regular-assessment-always-update',
        name: 'm-project-safety-reqular-assessment-always-update',
        component: () => import('@/views/m/project/safety/MobileSafetyRegularAssessmentAlwaysUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklist',
        name: 'm-project-safety-daily-checklist',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckList.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/daily-check-detail',
        name: 'm-project-safety-daily-check-detail',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckDetail.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklist-always',
        name: 'm-project-safety-daily-checklist-always',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckListAlways.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/daily-check-always-detail',
        name: 'm-project-safety-daily-check-always-detail',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckAlwaysDetail.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklog',
        name: 'm-project-asfety-daily-checklog',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLog.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklog-create',
        name: 'm-project-asfety-daily-checklog-create',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogCreate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/daily-checklog-update',
        name: 'm-project-asfety-daily-checklog-update',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklog-always',
        name: 'm-project-asfety-daily-checklog-always',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogAlways.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklog-always-create',
        name: 'm-project-asfety-daily-checklog-always-create',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogAlwaysCreate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/daily-checklog-always-update',
        name: 'm-project-asfety-daily-checklog-always-update',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogAlwaysUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklogall',
        name: 'm-project-safety-daily-checklogall',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogAll.vue'),
        meta: {
        }
      },
      {
        path: 'safety/daily-checklogall-create',
        name: 'm-project-safety-daily-checklogall-create',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogAllCreate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/daily-checklogall-update',
        name: 'm-project-safety-daily-checklogall-update',
        component: () => import('@/views/m/project/safety/MobileSafetyDailyCheckLogAllUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/equipment-checklist',
        name: 'm-project-safety-equipment-checklist',
        component: () => import('@/views/m/project/safety/MobileSafetyEquipmentCheckList.vue'),
        meta: {
        }
      },
      {
        path: 'safety/equipment-check-create',
        name: 'm-project-safety-equipment-check-create',
        component: () => import('@/views/m/project/safety/MobileSafetyEquipmentCheckCreate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/:postId/equipment-check-update',
        name: 'm-project-safety-equipment-check-update',
        component: () => import('@/views/m/project/safety/MobileSafetyEquipmentCheckUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'safety/equipment-checkresult',
        name: 'm-project-safety-equipment-checkresult',
        component: () => import('@/views/m/project/safety/MobileSafetyEquipmentCheckResult.vue'),
        meta: {
        }
      },

      //환경실적
      {
        path: 'state/daily-checklist',
        name: 'm-project-state-daily-checklist',
        component: () => import('@/views/m/project/state/MobileStateDailyCheckList.vue'),
        meta: {
        }
      },
      {
        path: 'state/daily-check-create',
        name: 'm-project-state-daily-check-create',
        component: () => import('@/views/m/project/state/MobileStateDailyCheckCreate.vue'),
        meta: {
        }
      },
      {
        path: 'state/:postId/daily-check-update',
        name: 'm-project-state-daily-check-update',
        component: () => import('@/views/m/project/state/MobileStateDailyCheckUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'state/monthly-checklist',
        name: 'm-project-state-monthly-checklist',
        component: () => import('@/views/m/project/state/MobileStateMonthlyCheckList.vue'),
        meta: {
        }
      },
      {
        path: 'state/monthly-check-create',
        name: 'm-project-state-monthly-check-create',
        component: () => import('@/views/m/project/state/MobileStateMonthlyCheckCreate.vue'),
        meta: {
        }
      },
      {
        path: 'state/:postId/monthly-check-update',
        name: 'm-project-state-monthly-check-update',
        component: () => import('@/views/m/project/state/MobileStateMonthlyCheckUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'state/monitoring-checklist',
        name: 'm-project-state-monitoring-checklist',
        component: () => import('@/views/m/project/state/MobileStateMonitoringCheckList.vue'),
        meta: {
        }
      },
      // 보건실적
      {
        path: 'hse/health-list',
        name: 'm-project-hse-health-list',
        component: () => import('@/views/m/project/hse/MobileHseHealthList.vue'),
        meta: {
        }
      },
      {
        path: 'hse/health-create',
        name: 'm-project-hse-health-create',
        component: () => import('@/views/m/project/hse/MobileHseHealthCreate.vue'),
        meta: {
        }
      },
      {
        path: 'hse/:postId/health-update',
        name: 'm-project-hse-health-update',
        component: () => import('@/views/m/project/hse/MobileHseHealthUpdate.vue'),
        meta: {
        }
      },


      //결재함
      {
        path: 'approval/request',
        name: 'm-project-approval-request',
        component: () => import('@/views/m/project/approval/MobileApprovalRequest.vue'),
        meta: {
        }
      },
      {
        path: 'approval/await',
        name: 'm-project-approval-await',
        component: () => import('@/views/m/project/approval/MobileApprovalAwait.vue'),
        meta: {
        }
      },
      {
        path: 'approval/process',
        name: 'm-project-approval-process',
        component: () => import('@/views/m/project/approval/MobileApprovalProcess.vue'),
        meta: {
        }
      },
      {
        path: 'approval/complete',
        name: 'm-project-approval-complete',
        component: () => import('@/views/m/project/approval/MobileApprovalComplete.vue'),
        meta: {
        }
      },
      {
        path: 'approval/reject',
        name: 'm-project-approval-reject',
        component: () => import('@/views/m/project/approval/MobileApprovalReject.vue'),
        meta: {
        }
      },
      {
        path: 'approval/reference',
        name: 'm-project-approval-reference',
        component: () => import('@/views/m/project/approval/MobileApprovalReference.vue'),
        meta: {
        }
      },

      // 시정 및 예방요청
      {
        path: 'prevention/safety-request',
        name: 'm-project-prevention-safety-request',
        component: () => import('@/views/m/project/prevention/MobilePreventionSafetyRequest.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/safety-request/create',
        name: 'm-project-prevention-safety-request-create',
        component: () => import('@/views/m/project/prevention/MobilePreventionSafetyRequestCreate.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/safety-request/:postId',
        name: 'm-project-prevention-safety-request-update',
        component: () => import('@/views/m/project/prevention/MobilePreventionSafetyRequestUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/environment-request',
        name: 'm-project-prevention-environment',
        component: () => import('@/views/m/project/prevention/MobilePreventionEnvironmentRequest.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/environment-request/create',
        name: 'm-project-prevention-environment-create',
        component: () => import('@/views/m/project/prevention/MobilePreventionEnvironmentRequestCreate.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/environment-request/:postId',
        name: 'm-project-prevention-environment-update',
        component: () => import('@/views/m/project/prevention/MobilePreventionEnvironmentRequestUpdate.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/health-request',
        name: 'm-project-prevention-health-request',
        component: () => import('@/views/m/project/prevention/MobilePreventionHealthRequest.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/health-request/create',
        name: 'm-project-prevention-health-request-create',
        component: () => import('@/views/m/project/prevention/MobilePreventionHealthRequestCreate.vue'),
        meta: {
        }
      },
      {
        path: 'prevention/health-request/:postId',
        name: 'm-project-prevention-health-request-update',
        component: () => import('@/views/m/project/prevention/MobilePreventionHealthRequestUpdate.vue'),
        meta: {
        }
      },


      ////////////////////////////////////////////////////////////////////////////
      {
        path: 'mypage/info-update',
        name: 'm-project-mypage',
        component: () => import('@/views/m/content/mypage/MobileMyPageInfoUpdate.vue'),
        meta: {
        }
      },


      ////////////////////////////////////////////////////////////////////////////
      //커뮤니티
      { // 커뮤니티 / CEO 메세지
        path: 'content/community/businessnews',
        name: 'm-content-community-businessnews',
        component: () => import('@/views/m/content/community/MobileCommunityBusinessnews.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: 'content/community/businessnews/create',
        name: 'm-content-community-businessnews-create',
        component: () => import('@/views/m/content/community/MobileCommunityBusinessnewsCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: 'content/community/businessnews/:postId',
        name: 'm-content-community-businessnews-detail',
        component: () => import('@/views/m/content/community/MobileCommunityBusinessnewsDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: 'content/community/businessnews/:postId/update',
        name: 'm-content-community-businessnews-update',
        component: () => import('@/views/m/content/community/MobileCommunityBusinessnewsUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / CEO 메세지
        path: 'content/community/businessnews/:postId/reply',
        name: 'm-content-community-businessnews-reply',
        component: () => import('@/views/m/content/community/MobileCommunityBusinessnewsReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'CEO 메세지'},
            {title: '목록', active: true}
          ],
          pageTitle: 'CEO 메세지',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'content/community/qna',
        name: 'm-content-community-qna',
        component: () => import('@/views/m/content/community/MobileCommunityQna.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'content/community/qna/create',
        name: 'm-content-community-qna-create',
        component: () => import('@/views/m/content/community/MobileCommunityQnaCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'content/community/qna/:postId',
        name: 'm-content-community-qna-detail',
        component: () => import('@/views/m/content/community/MobileCommunityQnaDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'content/community/qna/:postId/update',
        name: 'm-content-community-qna-update',
        component: () => import('@/views/m/content/community/MobileCommunityQnaUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'content/community/qna/:postId/reply',
        name: 'm-content-community-qna-reply',
        component: () => import('@/views/m/content/community/MobileCommunityQnaReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: 'content/community/healthinfo',
        name: 'm-content-community-healthinfo',
        component: () => import('@/views/m/content/community/MobileCommunityHealthInfo.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: 'content/community/healthinfo/create',
        name: 'm-content-community-healthinfo-create',
        component: () => import('@/views/m/content/community/MobileCommunityHealthInfoCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: 'content/community/healthinfo/:postId',
        name: 'm-content-community-healthinfo-detail',
        component: () => import('@/views/m/content/community/MobileCommunityHealthInfoDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: 'content/community/healthinfo/:postId/update',
        name: 'm-content-community-healthinfo-update',
        component: () => import('@/views/m/content/community/MobileCommunityHealthInfoUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요일정
        path: 'content/community/healthinfo/:postId/reply',
        name: 'm-content-community-healthinfo-reply',
        component: () => import('@/views/m/content/community/MobileCommunityHealthInfoReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: 'content/community/unitbusinessnews',
        name: 'm-content-community-unitbusinessnews',
        component: () => import('@/views/m/content/community/MobileCommunityUnitBusinessNews.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: 'content/community/unitbusinessnews/create',
        name: 'm-content-community-unitbusinessnews-create',
        component: () => import('@/views/m/content/community/MobileCommunityUnitBusinessNewsCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: 'content/community/unitbusinessnews/:postId',
        name: 'm-content-community-unitbusinessnews-detail',
        component: () => import('@/views/m/content/community/MobileCommunityUnitBusinessNewsDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: 'content/community/unitbusinessnews/:postId/update',
        name: 'm-content-community-unitbusinessnews-update',
        component: () => import('@/views/m/content/community/MobileCommunityUnitBusinessNewsUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: 'content/community/unitbusinessnews/:postId/reply',
        name: 'm-content-community-unitbusinessnews-reply',
        component: () => import('@/views/m/content/community/MobileCommunityUnitBusinessNewsReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'Home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요일정',
          parent: 'content_community_unitbusinessnews'
        }
      },

    ]
  }
]
